(function() {
  'use strict';

  if (window.DebriefsBogoCart && window.DebriefsBogoCart.__loaded) {
    return;
  }

  var BOGO_PRODUCT_ID = 6686157963373;
  var progressSelector = '[data-bogo-progress]';
  var reminderSelector = '[data-bogo-cart-reminder]';
  var refreshTimer = null;
  var observer = null;
  var stylesInjected = false;
  var variantScrollGuardAttached = false;

  function injectBogoStyles() {
    if (stylesInjected || !document.head) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'db-bogo-cart-runtime-styles';
    style.textContent = [
      '.db-bogo-cr{display:block!important;margin:0 0 10px!important;padding:8px 0 10px!important;border:none!important;background:transparent!important;box-shadow:none!important;}',
      '.db-bogo-cr[hidden]{display:none!important;}',
      '.db-bogo-cr__row{align-items:center!important;display:flex!important;gap:7px!important;}',
      '.db-bogo-cr__icon{color:#c0392b!important;flex-shrink:0!important;height:12px!important;width:12px!important;transition:color 300ms ease!important;}',
      '.db-bogo-cr[data-bogo-cr-state="done"] .db-bogo-cr__icon{color:#4a6e4a!important;}',
      '.db-bogo-cr__msg{color:#c0392b!important;flex:1!important;font-family:var(--text-font-family)!important;font-size:10px!important;font-style:var(--text-font-style)!important;font-weight:var(--text-font-bold-weight)!important;letter-spacing:1px!important;line-height:1.4!important;min-width:0!important;text-transform:uppercase!important;transition:color 300ms ease!important;}',
      '.db-bogo-cr__msg--done{color:#4a6e4a!important;}',
      '.db-bogo-cr__hint{color:#8c8c8c!important;font-family:var(--text-font-family)!important;font-size:9px!important;font-weight:500!important;letter-spacing:0.3px!important;line-height:1.3!important;margin:3px 0 0!important;}',
      '.db-bogo-cr__hint:empty,.db-bogo-cr__hint[hidden]{display:none!important;}',
      '.db-bogo-cr__count{flex-shrink:0!important;line-height:1!important;}',
      '.db-bogo-cr__n{color:#c0392b!important;font-family:var(--text-font-family)!important;font-size:14px!important;font-weight:var(--text-font-bold-weight)!important;transition:color 300ms ease!important;}',
      '.db-bogo-cr[data-bogo-cr-state="done"] .db-bogo-cr__n{color:#4a6e4a!important;}',
      '.db-bogo-cr__d{color:#b5b5b5!important;font-family:var(--text-font-family)!important;font-size:11px!important;font-weight:400!important;}',
      '.db-bogo-cr__bar{display:grid!important;gap:4px!important;grid-template-columns:repeat(4,1fr)!important;margin-top:6px!important;}',
      '.db-bogo-cr__seg{background:#eae6dd!important;height:5px!important;overflow:hidden!important;position:relative!important;transition:background 200ms ease!important;}',
      '.db-bogo-cr__seg.is-active{background:#c0392b!important;}',
      '.db-bogo-cr[data-bogo-cr-state="done"] .db-bogo-cr__seg.is-active{background:#4a6e4a!important;}',
      '@keyframes db-bogo-seg-sweep{0%{transform:translateX(-120%)}100%{transform:translateX(220%)}}',
      '.db-bogo-cr:not([data-bogo-cr-state="done"]) .db-bogo-cr__seg.is-remaining{background:#f5e4e1!important;}',
      '.db-bogo-cr:not([data-bogo-cr-state="done"]) .db-bogo-cr__seg.is-remaining::after{animation:db-bogo-seg-sweep 2.65s ease-in-out infinite!important;background:linear-gradient(90deg,rgba(192,57,43,0),rgba(192,57,43,.16) 22%,rgba(192,57,43,.48) 50%,rgba(192,57,43,.16) 78%,rgba(192,57,43,0))!important;content:""!important;inset:0!important;position:absolute!important;transform:translateX(-120%);width:88%!important;will-change:transform!important;}',
      '@media screen and (max-width:740px){.db-bogo-cr{padding:7px 0 9px!important;}}'
    ].join('');

    document.head.appendChild(style);
    stylesInjected = true;
  }

  function checkpointMarkup(number, label, isFree) {
    if (isFree) {
      return '<li class="db-bogo-motivator__step db-bogo-motivator__step--free" data-bogo-progress-step="4"><span class="db-bogo-motivator__marker"><span class="db-bogo-motivator__free-text">FREE</span></span><span>Free</span></li>';
    }

    return '<li class="db-bogo-motivator__step" data-bogo-progress-step="' + number + '"><span class="db-bogo-motivator__marker"><span class="db-bogo-motivator__marker-number">' + number + '</span><svg class="db-bogo-motivator__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.2 8.2l3 3L12.8 4.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter"/></svg></span><span>' + label + '</span></li>';
  }

  function upgradeProgressMarkup(bar) {
    var steps = bar.querySelector('.db-bogo-motivator__steps');

    if (!steps || steps.querySelector('.db-bogo-motivator__marker')) {
      return;
    }

    steps.innerHTML = [
      checkpointMarkup(1, 'Pair 1'),
      checkpointMarkup(2, 'Pair 2'),
      checkpointMarkup(3, 'Pair 3'),
      checkpointMarkup(4, 'Free', true)
    ].join('');
  }

  function upgradeProgressCTA(bar) {
    if (bar.querySelector('[data-bogo-progress-cta-row]')) {
      return;
    }

    var cta = document.createElement('div');
    cta.className = 'db-bogo-motivator__cta';
    cta.setAttribute('data-bogo-progress-cta-row', '');
    cta.hidden = true;
    cta.innerHTML = '<p class="db-bogo-motivator__nudge" data-bogo-progress-nudge></p><a href="#" class="db-bogo-motivator__action" data-bogo-progress-action>ADD A PAIR</a>';

    var action = cta.querySelector('[data-bogo-progress-action]');
    if (action) {
      action.addEventListener('click', function(e) {
        e.preventDefault();
        var form = document.querySelector('.product-form');
        if (form) {
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    bar.appendChild(cta);
  }

  function positionMiniCartReminder(reminder) {
    if (!reminder) {
      return;
    }

    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || !miniCart.contains(reminder)) {
      return;
    }

    var checkoutButton = miniCart.querySelector('button.checkout-button, .mini-cart__drawer-footer .button--primary');

    if (checkoutButton && checkoutButton.previousElementSibling !== reminder) {
      checkoutButton.parentNode.insertBefore(reminder, checkoutButton);
    }
  }

  function buildReminderElement() {
    var reminder = document.createElement('div');
    reminder.className = 'db-bogo-cr';
    reminder.setAttribute('data-bogo-cart-reminder', '');
    reminder.hidden = true;
    reminder.setAttribute('aria-hidden', 'true');
    reminder.innerHTML = [
      '<div class="db-bogo-cr__row">',
        '<svg focusable="false" width="12" height="12" class="db-bogo-cr__icon" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path></svg>',
        '<span class="db-bogo-cr__msg" data-bogo-cart-reminder-text></span>',
        '<span class="db-bogo-cr__count" data-bogo-cart-reminder-count></span>',
      '</div>',
      '<p class="db-bogo-cr__hint" data-bogo-cart-reminder-hint></p>',
      '<div class="db-bogo-cr__bar" aria-hidden="true">',
        '<span class="db-bogo-cr__seg" data-bogo-cart-seg="1"></span>',
        '<span class="db-bogo-cr__seg" data-bogo-cart-seg="2"></span>',
        '<span class="db-bogo-cr__seg" data-bogo-cart-seg="3"></span>',
        '<span class="db-bogo-cr__seg" data-bogo-cart-seg="4"></span>',
      '</div>'
    ].join('');
    return reminder;
  }

  function ensureReminderContainers() {
    var miniCart = document.getElementById('mini-cart');
    var checkoutButton = miniCart && miniCart.querySelector('button.checkout-button, .mini-cart__drawer-footer .button--primary');

    if (miniCart && checkoutButton && !miniCart.querySelector('[data-bogo-cart-reminder]')) {
      checkoutButton.parentNode.insertBefore(buildReminderElement(), checkoutButton);
    }

    var cartRecap = document.querySelector('.cart__recap');

    if (cartRecap && !cartRecap.querySelector('[data-bogo-cart-reminder]')) {
      var firstRecapBlock = cartRecap.querySelector('.cart__recap-block');
      var reminder = buildReminderElement();
      if (firstRecapBlock && firstRecapBlock.parentNode === cartRecap) {
        cartRecap.insertBefore(reminder, firstRecapBlock.nextSibling);
      } else {
        cartRecap.insertBefore(reminder, cartRecap.firstChild);
      }
    }
  }

  function restoreMediaStyles(media) {
    if (!media || !media.__dbBogoScrollGuardPrevious) {
      return;
    }

    var previous = media.__dbBogoScrollGuardPrevious;
    media.style.height = previous.height;
    media.style.minHeight = previous.minHeight;
    media.style.maxHeight = previous.maxHeight;
    media.style.overflow = previous.overflow;
    media.__dbBogoScrollGuardPrevious = null;
  }

  function holdViewportPosition(scrollY, ticksRemaining) {
    requestAnimationFrame(function() {
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (Math.abs(currentY - scrollY) > 8) {
        window.scrollTo(0, scrollY);
      }

      if (ticksRemaining > 0) {
        holdViewportPosition(scrollY, ticksRemaining - 1);
      }
    });
  }

  function freezeMediaDuringVariantChange() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 740px)').matches) {
      return;
    }

    var media = document.querySelector('product-media[product-handle="bogo"], product-media.product__media');

    if (!media) {
      return;
    }

    var rect = media.getBoundingClientRect();

    if (!rect.height) {
      return;
    }

    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!media.__dbBogoScrollGuardPrevious) {
      media.__dbBogoScrollGuardPrevious = {
        height: media.style.height,
        minHeight: media.style.minHeight,
        maxHeight: media.style.maxHeight,
        overflow: media.style.overflow
      };
    }

    clearTimeout(media.__dbBogoScrollGuardTimer);

    media.style.height = rect.height + 'px';
    media.style.minHeight = rect.height + 'px';
    media.style.maxHeight = rect.height + 'px';
    media.style.overflow = 'hidden';

    holdViewportPosition(scrollY, 10);

    media.__dbBogoScrollGuardTimer = setTimeout(function() {
      restoreMediaStyles(media);

      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (Math.abs(currentY - scrollY) > 8) {
        window.scrollTo(0, scrollY);
      }
    }, 450);
  }

  function initVariantScrollGuard() {
    if (variantScrollGuardAttached) {
      return;
    }

    variantScrollGuardAttached = true;

    document.addEventListener('change', function(event) {
      var target = event.target;

      if (!target || !target.matches || !target.matches('product-variants[handle="bogo"] [name^="option"]')) {
        return;
      }

      freezeMediaDuringVariantChange();
    }, true);
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function normaliseString(value) {
    return typeof value === 'string' ? value.toLowerCase() : '';
  }

  function isEligibleLineItem(item) {
    if (!item || typeof item !== 'object') {
      return false;
    }

    var productId = toNumber(item.product_id || item.productId);
    var handle = normaliseString(item.handle || item.product_handle || (item.product && item.product.handle));
    var url = normaliseString(item.url || item.product_url || item.productUrl);

    return productId === BOGO_PRODUCT_ID || handle === 'bogo' || url.indexOf('/products/bogo') !== -1;
  }

  function countEligibleQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce(function(total, item) {
      if (!isEligibleLineItem(item)) {
        return total;
      }

      return total + Math.max(0, toNumber(item.quantity));
    }, 0);
  }

  function getMilestoneState(quantity) {
    var count = Math.max(0, toNumber(quantity));
    var cycleQuantity = count % 4;
    var targetQuantity = count === 0 ? 4 : count;
    var remaining = 0;
    var done = false;

    if (count === 0) {
      remaining = 4;
    } else if (cycleQuantity === 0) {
      cycleQuantity = 4;
      done = true;
    } else {
      remaining = 4 - cycleQuantity;
      targetQuantity = count + remaining;
    }

    return {
      quantity: count,
      cycleQuantity: cycleQuantity,
      targetQuantity: targetQuantity,
      remaining: remaining,
      done: done,
      freePairCount: Math.floor(count / 4)
    };
  }

  function ordinal(number) {
    var value = Math.max(0, toNumber(number));
    var lastTwo = value % 100;
    var suffix = 'th';

    if (lastTwo < 11 || lastTwo > 13) {
      var last = value % 10;
      if (last === 1) {
        suffix = 'st';
      } else if (last === 2) {
        suffix = 'nd';
      } else if (last === 3) {
        suffix = 'rd';
      }
    }

    return value + suffix;
  }

  function getProgressState(quantity, currencyCode) {
    var milestone = getMilestoneState(quantity);
    var count = milestone.quantity;
    var cappedQuantity = milestone.cycleQuantity;
    var isAustralia = typeof currencyCode === 'string' && currencyCode.toUpperCase() === 'AUD';
    var state = {
      key: count === 0 ? 'empty' : 'building',
      quantity: count,
      cappedQuantity: cappedQuantity,
      percent: cappedQuantity * 25,
      targetQuantity: milestone.targetQuantity,
      remaining: milestone.remaining,
      message: 'Add all 4 pairs to your cart',
      cta: 'Your 4th pair is free at checkout.'
    };

    if (count > 0 && milestone.targetQuantity > 4 && !milestone.done) {
      state.message = 'Add all ' + milestone.targetQuantity + ' pairs to your cart';
      state.freePairCount = milestone.freePairCount;
      state.cta = milestone.remaining + ' more pair' + (milestone.remaining === 1 ? '' : 's') + ' to unlock another free pair.';
    } else if (count > 0 && count < 3) {
      state.cta = milestone.remaining + ' more pair' + (milestone.remaining === 1 ? '' : 's') + ' to unlock your free pair.';
    } else if (count === 3) {
      state.key = 'choose-free';
      state.message = 'Add 1 more pair to your cart';
      state.cta = 'Your 4th pair will be free at checkout.';
    } else if (milestone.done) {
      state.key = 'unlocked';
      state.freePairCount = milestone.freePairCount;
      state.message = milestone.freePairCount === 1 ? 'Free pair unlocked' : milestone.freePairCount + ' free pairs unlocked';
      if (isAustralia) {
        state.cta = 'Saving $' + (milestone.freePairCount * 36) + ' at checkout.';
      } else {
        state.cta = milestone.freePairCount === 1
          ? 'Getting one pair for free at checkout.'
          : 'Getting ' + milestone.freePairCount + ' pairs for free at checkout.';
      }
    }

    return state;
  }

  function getReminderState(quantity) {
    var milestone = getMilestoneState(quantity);
    var count = milestone.quantity;

    if (count === 0) {
      return { visible: false, done: false };
    }

    if (milestone.done) {
      return {
        visible: true,
        done: true,
        quantity: count,
        cycleQuantity: milestone.cycleQuantity,
        targetQuantity: milestone.targetQuantity,
        remaining: 0,
        freePairCount: milestone.freePairCount,
        text: milestone.freePairCount === 1 ? 'Free pair unlocked' : milestone.freePairCount + ' free pairs unlocked',
        hint: '',
        count: count + '/' + milestone.targetQuantity
      };
    }

    var targetLabel = ordinal(milestone.targetQuantity);
    var text = milestone.remaining === 1
      ? 'Add 1 more pair to get your ' + targetLabel + ' free'
      : 'Add ' + milestone.remaining + ' more pairs to get your ' + targetLabel + ' free';

    return {
      visible: true,
      done: false,
      quantity: count,
      cycleQuantity: milestone.cycleQuantity,
      targetQuantity: milestone.targetQuantity,
      remaining: milestone.remaining,
      freePairCount: milestone.freePairCount,
      text: text,
      hint: 'You need ' + milestone.targetQuantity + ' pairs in your cart to claim this offer',
      count: count + '/' + milestone.targetQuantity
    };
  }

  function getCartJsonUrl() {
    var cartUrl = window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl
      ? window.themeVariables.routes.cartUrl
      : '/cart';

    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function setText(root, selector, text) {
    var element = root.querySelector(selector);

    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function updateProgressBars(quantity, cart) {
    var state = getProgressState(quantity, cart && cart.currency);
    var bars = document.querySelectorAll(progressSelector);

    bars.forEach(function(bar) {
      injectBogoStyles();
      upgradeProgressMarkup(bar);
      upgradeProgressCTA(bar);

      var progress = bar.querySelector('[data-bogo-progress-bar]');
      var meter = bar.querySelector('[data-bogo-progress-meter]');
      var steps = bar.querySelectorAll('[data-bogo-progress-step]');

      bar.setAttribute('data-bogo-state', state.key);
      bar.style.setProperty('--db-bogo-progress', state.percent + '%');

      if (meter) {
        meter.setAttribute('aria-valuenow', String(state.percent));
      }

      if (progress) {
        progress.style.width = state.percent + '%';
      }

      steps.forEach(function(step) {
        var stepValue = toNumber(step.getAttribute('data-bogo-progress-step'));
        var isActive = stepValue <= state.cappedQuantity;
        var isRemaining = state.key !== 'unlocked' && stepValue > state.cappedQuantity;
        step.classList.toggle('is-active', isActive);
        step.classList.toggle('is-remaining', isRemaining);
        step.setAttribute('aria-current', isActive && stepValue === state.cappedQuantity ? 'step' : 'false');
      });

      setText(bar, '[data-bogo-progress-count]', state.quantity + '/' + state.targetQuantity);
      setText(bar, '[data-bogo-progress-message]', state.message);
      setText(bar, '[data-bogo-progress-cta]', state.cta);
    });
  }

  function updateReminders(quantity) {
    var state = getReminderState(quantity);
    injectBogoStyles();
    ensureReminderContainers();

    var reminders = document.querySelectorAll(reminderSelector);

    reminders.forEach(function(reminder) {
      positionMiniCartReminder(reminder);

      reminder.hidden = !state.visible;
      reminder.setAttribute('aria-hidden', state.visible ? 'false' : 'true');
      reminder.setAttribute('data-bogo-cr-state', state.done ? 'done' : state.visible ? 'building' : '');

      if (!state.visible) {
        return;
      }

      setText(reminder, '[data-bogo-cart-reminder-text]', state.text);
      var textEl = reminder.querySelector('[data-bogo-cart-reminder-text]');
      if (textEl) {
        textEl.classList.toggle('db-bogo-cr__msg--done', state.done);
      }

      var hintEl = reminder.querySelector('[data-bogo-cart-reminder-hint]');
      if (hintEl) {
        if (hintEl.textContent !== state.hint) {
          hintEl.textContent = state.hint;
        }
        hintEl.hidden = !state.hint;
      }

      var countEl = reminder.querySelector('[data-bogo-cart-reminder-count]');
      if (countEl) {
        countEl.hidden = false;
        var parts = state.count.split('/');
        var nextCountHtml = '<span class="db-bogo-cr__n">' + parts[0] + '</span><span class="db-bogo-cr__d">/' + parts[1] + '</span>';
        var hasSplitCount = countEl.querySelector('.db-bogo-cr__n') && countEl.querySelector('.db-bogo-cr__d');
        if (!hasSplitCount || countEl.textContent.replace(/\s+/g, '') !== state.count) {
          countEl.innerHTML = nextCountHtml;
        }
      }

      var segs = reminder.querySelectorAll('[data-bogo-cart-seg]');
      var cycle = state.cycleQuantity;
      segs.forEach(function(seg) {
        var step = toNumber(seg.getAttribute('data-bogo-cart-seg'));
        seg.classList.toggle('is-active', step <= cycle);
        seg.classList.toggle('is-remaining', !state.done && step > cycle);
      });
    });
  }

  function updateFromCart(cart) {
    var quantity = countEligibleQuantity(cart);
    updateProgressBars(quantity, cart);
    updateReminders(quantity);
  }

  async function refreshFromCart() {
    try {
      var response = await fetch(getCartJsonUrl(), {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        return;
      }

      updateFromCart(await response.json());
    } catch (error) {
      return;
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromCart, delay || 0);
  }

  function observeCartDrawer() {
    var miniCart = document.getElementById('mini-cart');

    if (!miniCart || typeof MutationObserver === 'undefined') {
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver(function() {
      scheduleRefresh(150);
    });

    observer.observe(miniCart, { childList: true, subtree: true });
  }

  function initBogoCart() {
    var cartEventTarget = document.documentElement || document;

    scheduleRefresh(250);
    observeCartDrawer();
    initVariantScrollGuard();

    cartEventTarget.addEventListener('cart:refresh', function() {
      scheduleRefresh(900);
    });

    cartEventTarget.addEventListener('cart:updated', function(event) {
      if (event.detail && event.detail.cart) {
        updateFromCart(event.detail.cart);
      } else {
        scheduleRefresh(150);
      }
    });

    cartEventTarget.addEventListener('variant:added', function() {
      scheduleRefresh(900);
    });
  }

  window.DebriefsBogoCart = {
    __loaded: true,
    countEligibleQuantity: countEligibleQuantity,
    getProgressState: getProgressState,
    getReminderState: getReminderState,
    getMilestoneState: getMilestoneState,
    refresh: refreshFromCart,
    update: updateFromCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBogoCart);
  } else {
    initBogoCart();
  }
})();
